import { createAsyncThunk } from '@reduxjs/toolkit';
import { cancelAiLicence as cancelAiLicenceService } from '../../services/cancelAiLicence.service';
import { loadAdminAiLicences } from './loadAdminAiLicences.thunk';

/**
 * Cancels a business's licence, then reloads the licence list so the row
 * shows its new state before the save is reported done.
 */
export const cancelAiLicence = createAsyncThunk(
  'adminAi/cancelAiLicence',
  async (businessId, { dispatch, rejectWithValue }) => {
    try {
      await cancelAiLicenceService(businessId);
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to cancel the AI licence'
      );
    }
    await dispatch(loadAdminAiLicences());
    return { businessId };
  }
);
